var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMobileLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.8503 17.2075C31.1382 17.2075 31.3715 16.2663 31.3715 15.1053C31.3715 13.9443 31.1382 13.0031 30.8503 13.0031C30.5624 13.0031 30.329 13.9443 30.329 15.1053C30.329 16.2663 30.5624 17.2075 30.8503 17.2075Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.3098 16.7871L31.0066 17.5229L29.7556 18.2586V16.7871V15.263L31.0066 16.0513L32.3098 16.7871Z",
    fill: "#F47833"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.6374 17.5229L27.5662 16.4192L29.3907 15.3681C29.3907 14.2644 29.3907 14.2644 29.3907 14.2644L24.9598 11.3739L3.17017 33.3421H6.9234L10.8851 29.7157H20.581C20.581 29.7157 29.4428 28.1916 29.4428 19.7302V19.6776L27.6183 18.6265L25.6374 17.5229Z",
    fill: "#FFD233"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5662 16.4192L25.6375 17.5229L27.5662 18.6265L29.3907 19.6776C29.3907 17.4177 29.3907 16.1039 29.3907 15.3155L27.5662 16.4192Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M29.3907 16.6294C29.3907 18.2586 29.13 19.52 28.8172 19.52C28.5045 19.52 28.2438 18.2061 28.2438 16.6294C28.2438 16.0513 28.296 15.5783 28.3481 15.1053C28.4523 14.2644 28.6087 13.6863 28.8172 13.6863C29.13 13.6863 29.3907 15.0002 29.3907 16.6294Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M28.8173 15.1053H20.9459L19.5906 16.3666",
    stroke: "black",
    strokeWidth: 0.6603,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3395 6.17089C14.6905 6.17089 11.6149 7.695 9.16489 10.7432C7.54891 12.898 6.76699 15.263 6.76699 17.8382C6.76699 22.4631 9.0085 26.0369 13.5437 28.5595C15.2639 29.1902 16.7756 29.5581 18.0788 29.5581H18.6522C23.031 29.5581 26.5236 27.2456 29.0779 22.6208H34.6035C34.7077 22.6208 34.812 22.7259 34.812 22.831C33.7173 26.2996 31.8928 29.0325 29.2864 31.1348C26.1066 33.8151 22.614 35.129 18.965 35.129H17.8182C13.0224 35.129 8.79999 32.9742 5.04676 28.7172C2.49247 25.4588 1.24139 21.9375 1.24139 18.0484V17.6805C1.24139 11.479 4.16058 6.53878 10.0511 2.75478C12.7096 1.33578 15.4203 0.600006 18.1831 0.600006H18.3916L18.3395 6.17089Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileLogo);
export default __webpack_public_path__ + "static/media/mobile-logo.95f8457829ebf9afdbc40e54e091579e.svg";
export { ForwardRef as ReactComponent };